import React from 'react'
import sortCinemas from '../../functions/sortCinemas'
import Translation from '../Translation/cont/Translation'

const PageCinemasContent = ({cinemas, clientCinemaId}) => {
    if(!cinemas || !clientCinemaId) {
        return ''
    }

    const sortedAlphabeticalCinemas = sortCinemas(clientCinemaId, cinemas)

    return sortedAlphabeticalCinemas.map(cinemaId => {
        const currentCinema = cinemas[cinemaId]
        const {pk, nameDisplay, nameShort, website} = currentCinema
        
        return (
            <div className="cinema-wrapper" key={pk}>
                <div className="cinema text-large-light">
                    {nameDisplay} <span className="cinema-short">({nameShort})</span>
                </div>
                
                {website && <a href={website + '/pmkino/backend'} className="button text-large-light">
                    <Translation id='cinemas_to_backoffice'/>
                </a>}
                
                {website && <a href={website} className="button text-large-light">
                    <Translation id='cinemas_to_website'/>
                </a>}
            </div>
        )
    })
}


export default PageCinemasContent






